export const environment = {
  production: false,
  defaultLang: "fr",
  keycloak: {
    url: "https://keycloak.dashypay.com",
    realm: "mvp-dashy",
    clientId: "backoffice",
  },
  studioUrl: "https://devstudio.dashypay.com/",
  // clarityProjectId: "rn0l1k5u2h",
  defaultDashyCompanyId: "DSH01",
  backofficeUrl: "https://backoffice.dashypay.com/",
  backofficeMobileUrl: "https://pwa-dev.dashypay.com/",
  erpApiUrl: "https://dev.dashypay.com/erp-api",
  coreApiUrl: "https://dev.dashypay.com/core-api",
  wabaApiUrl: "http://localhost:8031",
  wabaBotApiUrl: "https://dev.dashypay.com/waba-api",
  paymentApiUrl: "https://dev.dashypay.com/payment-api",
  compSecretKey: "de8243df96a9e898",
  plkCustomisedAppearance: true,
  firebase: {
    apiKey: "AIzaSyB1Uoc3t5wKjYFC-MFJbSHOn_YKAifKn2s",
    authDomain: "dashy-bb179.firebaseapp.com",
    projectId: "dashy-bb179",
    storageBucket: "dashy-bb179.firebasestorage.app",
    messagingSenderId: "999456120351",
    appId: "1:999456120351:web:b62a59b0e9d219b68ebf2a",
  },
  meta: {
    appId: "532395029698625",
    sdkVersion: "v21.0",
    signup: {
      configId: "1106303334484141",
      responseType: "code",
      featureType: "whatsapp_business_app_onboarding",
      sessionInfoVersion: "3",
    },
    catalogSignup: {
      configId: "1106303334484141", //To verify on DashyPay https://developers.facebook.com/
      responseType: "code",
      featureType: "whatsapp_business_app_onboarding",
      sessionInfoVersion: "3",
    },
    instagramSignup: {
      // Facebook Login for Business configuration dedicated to Instagram.
      // Never reuse a WhatsApp Embedded Signup configuration here.
      configId: "27793100340331577",
    },
    webhookCallbackUrl:
      "https://dev.dashypay.com/waba-api/v1/meta-waba/webhook",
  },
};
